<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>广告管理</el-breadcrumb-item>
      <el-breadcrumb-item>司法缴费管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="8">
          <!-- 搜索与添加区域 -->
          <el-date-picker
            v-model="QueryDate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-col>

        <el-col :span="1.5">
          <el-button
            v-if="hasPerm('adv:advcourthouseorderform:search')"
            type="primary"
            @click="QueryData"
            >查询</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button
            v-if="hasPerm('adv:advcourthouseorderform:export')"
            type="primary"
            @click="exportExcel"
            >导出Excel</el-button
          >
        </el-col>
      </el-row>

      <el-table
        size="mini"
        :data="OrderformList"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
        default-expand-all
      >
        <el-table-column
          label="订单号"
          prop="tradeno"
          width="150px"
        ></el-table-column>
        <el-table-column
          label="标的"
          prop="biaodi"
          width="350px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="名称"
          prop="name"
          width="350px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="电话"
          prop="phone"
          width="100px"
        ></el-table-column>
        <el-table-column
          label="法院"
          prop="courthouse"
          width="210px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="价格"
          prop="price"
          width="50px"
        ></el-table-column>
        <el-table-column
          label="下单日期"
          prop="paydate"
          width="90px"
        ></el-table-column>
        <el-table-column
          label="下单时间"
          prop="paytime"
          width="90px"
        ></el-table-column>
        <!--
        <el-table-column prop="status" label="进程" width="500px">
          <template slot-scope="scope">
            <el-steps
              :space="100"
              :active="scope.row.status"
              finish-status="success"
              align-center
            >
              <el-step
                :title="item.title"
                :status="item.status"
                :key="item.index"
                v-for="item in scope.row.stepdata"
                @click.native="on_stepclick(scope.row)"
              ></el-step>
            </el-steps>
          </template>
        </el-table-column>-->

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="hasPerm('adv:advcourthouseorderform:unpay')"
              type="primary"
              size="mini"
              @click="unpay(scope.row)"
              >退款</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[2, 5, 10, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <el-dialog
        title="退款"
        :visible.sync="unpaydialogVisible"
        width="30%"
        :before-close="handleCloseunpay"
      >
        <el-form
          :model="UnPayForm"
          size="mini"
          :inline="true"
          label-width="80px"
        >
          <el-form-item>
            <el-radio-group v-model="unpaySelect" @change="UnpaySelect">
              <el-radio :label="1">全额退款</el-radio>
              <el-radio :label="2">扣手续费</el-radio>
              <el-radio :label="3">部分退款</el-radio>
            </el-radio-group></el-form-item
          >
          <el-form-item label="退款金额">
            <el-input
              v-model="UnPayForm.unpayPrice"
              :readonly="priceEnable"
              placeholder="请输入退款金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="UnPayForm.password"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="unpaydialogVisible = false">取消</el-button>
          <el-button type="primary" @click="unpayOK">退款</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { GetAdvCourseOrderformList, CourthouseExcel } from "@/request/api";
import { baseURL } from "@/request/request";
export default {
  data() {
    return {
      OrderformList: [],
      total: 0,
      startdate: "",
      enddate: "",
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 5,
      },
      UnPayForm: {
        id: "",
        tradeno: "",
        unpayPrice: "",
        password: "",
        price: "",
      },
      unpaydialogVisible: false,
      unpaySelect: "0",
      priceEnable: false,
      baseurl: baseURL,
      QueryDate: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.QueryDate = [
      new Date(new Date().toLocaleDateString()).getTime(),
      new Date(new Date().toLocaleDateString()).getTime() +
        (24 * 60 * 60 * 1000 - 1),
    ];
    this.getOrderformList();
  },
  methods: {
    unpayCancel() {
      this.unpaydialogVisible = false;
    },
    handleCloseunpay() {
      this.unpaydialogVisible = false;
    },

    UnpaySelect(e) {
      switch (e) {
        case 1:
          this.priceEnable = true;
          this.UnPayForm.unpayPrice = this.UnPayForm.price;
          break;
        case 2:
          this.priceEnable = true;
          this.UnPayForm.unpayPrice = this.UnPayForm.price * 0.994;
          break;
        case 3:
          this.UnPayForm.unpayPrice = "";
          this.priceEnable = false;
          break;
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getOrderformList();
    },
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getOrderformList();
    },
    QueryData() {
      this.getOrderformList();
    },
    getOrderformList() {
      var param = {
        startdate: this.confirmDate(this.QueryDate[0]),
        enddate: this.confirmDate(this.QueryDate[1]),
      };
      GetAdvCourseOrderformList(param).then((res) => {
        if (res.data.code === 1) {
          this.OrderformList = res.data.data;
        }
      });
    },

    confirmDate(v) {
      var endvalue = new Date(v);
      var Y = endvalue.getFullYear() + "-";
      var M =
        (endvalue.getMonth() + 1 < 10
          ? "0" + (endvalue.getMonth() + 1)
          : endvalue.getMonth() + 1) + "-";
      var D =
        endvalue.getDate() + 1 < 10
          ? "0" + endvalue.getDate()
          : endvalue.getDate();
      return Y + M + D;
    },

    exportExcel() {
      var param = {
        startdate: this.confirmDate(this.QueryDate[0]),
        enddate: this.confirmDate(this.QueryDate[1]),
      };
      CourthouseExcel(param).then((res) => {
        console.log(res);
        if (res.data.code === 1) {
          window.location.href = this.baseurl + "/" + res.data.data;
        }
      });
    },

    unpay(row) {
      this.unpaydialogVisible = true;
      this.UnPayForm.unpayPrice = "";
      this.UnPayForm.password = "";
      this.UnPayForm.price = row.price;
      this.UnPayForm.tradeno = row.tradeno;
      this.UnPayForm.id = row.id;
    },

    unpayOK(row) {
      this.UnPayForm.unpayPrice = row.price;
      if (this.UnPayForm.unpayPrice > this.UnPayForm.price) {
        this.$message({
          message: "退款金额不能大于付款金额",
          type: "warning",
        });
      } else {
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();

        if (this.UnPayForm.password === "unpay" + mm + dd) {
          // let param = {
          //   id: this.UnPayForm.id,
          //   tradeno: this.UnPayForm.tradeno,
          //   price: this.UnPayForm.price,
          //   refundprice: this.UnPayForm.unpayPrice,
          // };
          // AdvUnPay(param).then((res) => {
          //   if (res.data.code === 1) {
          //     this.getOrderformList();
          //   }
          //   this.$message({
          //     message: res.data.msg,
          //     type: res.data.code === 1 ? "success" : "warning",
          //   });
          // });
        } else {
          this.$message({
            message: "密码不正确，请联系管理员",
            type: "warning",
          });
        }
      }
      this.unpaydialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>